<template>
  <div class="tender-legal">
    <div class="title">{{ $t('tender-details.legal') }}</div>

    <div v-if="tender.coveredBy">
      <div class="subtitle">{{ $t('tender-details.legals.applicable-agreement') }}</div>
      <div class="tender-legal__content">
        <div v-for="law in tender.coveredBy" :key="law">{{ law }}</div>
      </div>
    </div>

    <div class="subtitle">{{ $t('tender-details.legals.reserve') }}</div>
    <div class="tender-legal__content">
      {{ $t('page.tenders.property', { platform: platformName }) }}
    </div>
  </div>
</template>

<script>
import PlatformName from '@/mixins/platform-name-mixin';

export default {
  name: 'TenderLegal',
  mixins: [PlatformName],
  props: {
    tender: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    platformName() {
      return this.getPlatformName(this.tender.source.id);
    },
  },
};
</script>

<style lang="scss">
.tender-legal {
  padding: 2rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  background: $color-white;
  border-radius: $border-radius-root;

  &__content {
    font-size: 14px;
    color: $color-normal-pale;
    font-family: $font-families;
    line-height: 1.4rem;
  }

  @media screen and (max-width: 1080px) {
    margin-right: 0px;
    margin-bottom: 1rem;
  }
}
</style>
